import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MapPinService } from './map-pin.service';
import { GoogleMapsComponent } from '../google-maps/google-maps.component';
import { TripLocationType } from 'app/core/enums/trip-location.enum';

@Component({
  selector: 'app-map-pin-adjustment',
  templateUrl: './map-pin-adjustment.component.html',
  styleUrls: ['./map-pin-adjustment.component.scss']
})
export class MapPinAdjustmentComponent implements OnInit, OnDestroy {
  @ViewChild('map') map: GoogleMapsComponent;
  @Input() locationName: string;

  isOpen = false;
  currentLat: number;
  currentLng: number;
  initialLat: number;
  initialLng: number;
  markerIcon: string;
  private marker: any;
  private subscriptions: Subscription[] = [];
  private mapReady = false;
  private maxRadiusMeters?: number;

  constructor(private service: MapPinService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.service.config$.subscribe(config => {
          if (config) {
            this.currentLat = config.latitude;
            this.currentLng = config.longitude;
            this.initialLat = config.latitude;
            this.initialLng = config.longitude;
            this.markerIcon = config.markerIcon;
            this.maxRadiusMeters = config.maxRadiusMeters;
            this.isOpen = true;
            if (this.mapReady) {
              setTimeout(() => this.initMarker(), 100);
            }
          } else {
            this.closeModal();
          }
        }
      )
    );
  }

  onMapReady() {
    this.mapReady = true;
    if (this.isOpen) { setTimeout(() => this.initMarker(), 100); }
  }

  private initMarker() {
    if (this.maxRadiusMeters && this.maxRadiusMeters > 0) {
      this.map.addCircle(this.initialLat, this.initialLng, this.maxRadiusMeters);
    }

    const label = !this.locationName ? 'P' : this.locationName === TripLocationType.PickUp ? 'PU' : 'DO';

    this.marker = this.map.addDraggableMarker(
      this.currentLat,
      this.currentLng,
      this.markerIcon,
      (pos) => {
        if (this.maxRadiusMeters && this.maxRadiusMeters > 0) {
          const initialPos = this.map.latLng(this.initialLat, this.initialLng);
          const newPos = this.map.latLng(pos.latitude, pos.longitude);
          const dist = this.map.distance(initialPos, newPos);

          if (dist > this.maxRadiusMeters) {
            const boundaryPos = this.map.computeBoundaryPoint(initialPos, newPos, this.maxRadiusMeters);
            this.marker.setPosition(boundaryPos);
            this.currentLat = boundaryPos.lat();
            this.currentLng = boundaryPos.lng();
            return;
          }
        }
        this.currentLat = pos.latitude;
        this.currentLng = pos.longitude;
      },
      label
    );

    this.map.moveCamera(this.currentLat, this.currentLng, 17);
  }

  onSave() {
    this.service.confirm({latitude: this.currentLat, longitude: this.currentLng, locationName: this.locationName});
  }

  closeModal() {
    if (!this.map) { return; }
    this.map.clearMarkers();
    this.map.clearCircles();
    this.isOpen = false;
    this.mapReady = false;
  }

  get disableSaveButton(): boolean {
    return this.currentLat === this.initialLat && this.currentLng === this.initialLng;
  }

  ngOnDestroy() {
    this.closeModal();
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/map-pin-adjustment/map-pin-adjustment.component.ts